import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import _ from "underscore";
import { connect } from "react-redux";

import { reset } from "../actions/resetPasswordActions";

import ErrorAlert from "../components/ErrorAlert";

class ResetPasswordPage extends Component {
  componentDidMount() {
    this.props.recaptchaInvalid();
  }

  componentWillUnmount() {
    this.props.clearResetPassword();
  }

  onSubmit = event => {
    event.preventDefault();
    this.props.reset(this.emailOrUsername.value);
  };

  onRecaptchaChange = event => {
    this.props.recaptchaValid();
  };

  onEmailOrUsernameChange = event => {
    if (_.isEmpty(event.target.value)) {
      this.props.emailUsernameInvalid();
    } else {
      this.props.emailUsernameValid();
    }
  };

  render() {
    if (this.props.loading) {
      return <div></div>;
    }

    if (!this.props.enabled) {
      return <div>Reset password not enabled</div>;
    }

    if (this.props.resetPasswordInProgress) {
      return (
        <main>
          <h1>{this.props.text("resetpassword.processing")}</h1>
          <br />
          <br />
          <div>
            <div className="loader" />
          </div>
        </main>
      );
    }

    if (this.props.resetPasswordComplete) {
      return (
        <main>
          <h1>{this.props.text("resetpassword.completed")}</h1>
          <p>{this.props.text("resetpassword.explanation_complete")}</p>
        </main>
      );
    }

    var errorText = "";
    if (this.props.serverError === true) {
      errorText = this.props.text("network.networkError");
    } else if (this.props.resetPasswordErrorText === "Not Found") {
      errorText = this.props.text("error.usernameNotExists");
    } else {
      errorText =
        this.props.text("resetpassword.error") +
        " (" +
        this.props.resetPasswordErrorText +
        ")";
    }

    return (
      <main>
        <h1>{this.props.text("resetpassword.title")}</h1>

        {this.props.resetPasswordError && <ErrorAlert text={errorText} />}

        <form onSubmit={this.onsubmit}>
          <div className="form-group">
            <p>{this.props.text("resetpassword.explanation")}</p>
            <label htmlFor="emailOrUsername" className="font-weight-bold">
              {this.props.text("resetpassword.email_or_username")}
            </label>
            <div>
              <input
                type="text"
                onChange={this.onEmailOrUsernameChange}
                className="form-control"
                id="emailOrUsername"
                placeholder={this.props.text("resetpassword.email_or_username")}
                value={this.props.emailOrUsername}
                required
                ref={obj => {
                  this.emailOrUsername = obj;
                }}
              />
            </div>
          </div>

          {this.props.config.resetpassword.recaptcha && (
            <div>
              <br />
              <ReCAPTCHA
                sitekey={this.props.recaptchakey}
                onChange={this.props.recaptchaValid}
              />
              <br />
            </div>
          )}

          <div className="form-group">
            <div>
              <button
                disabled={this.props.disabled}
                type="submit"
                className="btn button"
                onClick={this.onSubmit}
              >
                {this.props.text("common.reset")}
              </button>
            </div>
          </div>
        </form>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.config.text == null ? true : false,
    resetPasswordInProgress: state.resetPassword.resetPasswordInProgress,
    resetPasswordComplete: state.resetPassword.resetPasswordComplete,
    serverError: state.network.serverError,
    resetPasswordError: state.resetPassword.resetPasswordError,
    resetPasswordErrorText: state.resetPassword.resetPasswordErrorText,
    disabled:
      (state.config.resetpassword &&
        state.config.resetpassword.recaptcha === true &&
        state.resetPassword.recaptchavalid === false) ||
      state.resetPassword.emailusernamevalid === false
        ? true
        : false,
    text: str => state.config.text(str),
    enabled: state.config.mode.resetpassword_enabled,
    recaptchakey: state.config.recaptchakey,
    config: {
      registration: state.config.registration,
      resetpassword: state.config.resetpassword,
    },
  };
};

const mapDispatchToProps = dispatch => {
  return {
    recaptchaValid: () => {
      dispatch({ type: "RESETPASSWORD_RECAPTCHA_VALID" });
    },
    recaptchaInvalid: () => {
      dispatch({ type: "RESETPASSWORD_RECAPTCHA_INVALID" });
    },
    emailUsernameValid: () => {
      dispatch({ type: "RESETPASSWORD_EMAILUSERNAME_VALID" });
    },
    emailUsernameInvalid: () => {
      dispatch({ type: "RESETPASSWORD_EMAILUSERNAME_INVALID" });
    },
    clearResetPassword: () => {
      dispatch({ type: "RESETPASSWORD_CLEAR" });
    },
    reset: emailOrUsername => {
      dispatch(reset(emailOrUsername));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);






// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js